/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import './ScrollToTop.scss';

export default function ScrollToTop(): JSX.Element {
  const [scrollTop, setScrollTop] = useState(0);

  const onScroll = (e: any) => {
    setScrollTop(e.target.documentElement.scrollTop);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <span
      title="Scroll to top"
      onClick={scrollToTop}
      className={`ScrollToTop pdf-exclude ${scrollTop > 1000 ? 'show' : 'hide'}`}
    />
  );
}
